// Library
import React, { Component } from "react";

// Components
import { Modal, Button } from "react-bootstrap";
import { PreferencesContext } from '../../../contexts/PreferencesContext';

class SuccessModal extends Component {
  static contextType = PreferencesContext;

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header closeButton>
        <Modal.Title>{this.context.t('success')}</Modal.Title>
        </Modal.Header>
      <Modal.Body>{this.context.t('success_question_reviewed')}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={this.props.handleClose}>
          {this.context.t('action_close')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SuccessModal;
